<template>
  <div class="pay_manage_main">
    <div class="pay_manage_title">
      <span class="title">首页</span>
    </div>
    <!-- <ul class="manage_header">
      <li class="header_item">
        <h5>当月总营收</h5>
        <p class="price">{{ list.afee }}</p>
      </li>
      <li class="header_item">
        <h5>当月订餐营收</h5>
        <p class="price">{{ list.bfee }}</p>
      </li>
      <li class="header_item">
        <h5>其他营收</h5>
        <p class="price">{{ list.cfee }}</p>
      </li>
      <li class="header_item">
        <h5>当月入库</h5>
        <p class="price">{{list.storageNumber}}</p>
      </li>
      <li class="header_item">
        <h5>当月订单总数</h5>
        <p class="price">{{ list.atimes }}</p>
      </li>
      <li class="header_item">
        <h5>当月订餐数</h5>
        <p class="price">{{ list.btimes }}</p>
      </li>
      <li class="header_item">
        <h5>其他</h5>
        <p class="price">{{ list.ctimes }}</p>
      </li>
<!--      <li class="header_item">-->
<!--        <h5>当月消耗</h5>-->
<!--        <p class="price">{{list.consumption}}</p>-->
<!--      </li>-->
    <!-- </ul>  -->
    <div class="manage_table_container">
      <el-table
        ref="multipleTable"
        :data="tableDate"
        tooltip-effect="dark"
        highlight-current-row
        :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
        border
      >
        <el-table-column type="selection" width="50" align="center"> </el-table-column>
        <el-table-column
          type="index"
          width="70"
          label="序号"
          align="center"
        ></el-table-column>
        <el-table-column prop="customerName" label="姓名" align="center">
        </el-table-column>
        <el-table-column prop="orderId" label="是否订餐" align="center">
          <template scope="scope">
            <span v-if="scope.row.orderId">已订餐</span>
            <span v-else>未订餐</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderWay" label="订餐方式" align="center" width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.orderWay == 0">按月</span>
            <span v-if="scope.row.orderWay == 1">按次</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderType" label="就餐类型" align="center">
          <template scope="scope">
            <span v-if="scope.row.orderType == 1">早餐</span>
            <span v-if="scope.row.orderType == 2">中餐</span>
            <span v-if="scope.row.orderType == 3">晚餐</span>
            <!-- <span v-if="scope.row.isOrder == 3">未就餐</span>
            <span v-if="scope.row.isOrder == 4">已就餐</span>
            <span v-if="scope.row.isOrder == 5">未取餐</span>
            <span v-if="scope.row.isOrder == 6">已取餐</span> -->
          </template>
        </el-table-column>
        <el-table-column prop="paymentAmount" label="支付金额" align="center">
        </el-table-column>
        <el-table-column prop="payType" label="支付方式" align="center">
          <template scope="scope">
            <span v-if="scope.row.payType == 1">人脸识别</span>
            <span v-if="scope.row.payType == 2">支付宝</span>
            <span v-if="scope.row.payType == 3">微信</span>
            <span v-if="scope.row.payType == 4">现金</span>
          </template>
        </el-table-column>
        <el-table-column prop="payTime" label="支付时间" width="200" align="center">
        </el-table-column>
        <el-table-column prop="operation" label="操作" align="center" width="140px">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="查看" placement="top-start">
              <!-- <img
                src="../../../assets/imgs/table_edit.png"
                alt=""
                @click="handleEdit(scope.row)"
                style="cursor: pointer"
              /> -->
               <button style="color: #000" class="iconfont icon-chakan tabBtn"  @click="handleEdit(scope.row)"></button>
            </el-tooltip>
           
            <!-- <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
              <img
                src="../../../assets/imgs/table_delete.png"
                alt=""
                @click="deleteId(scope.row)"
                style="margin-left: 12px; cursor: pointer"
              />
            </el-tooltip> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination_container">
        <div class="pagination">
          <p></p>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="查看"
      :visible.sync="dialogVisible"
      width="990px"
      class="dialog_container"
    >
      <div class="dialog_content">
        <el-form label-width="100px" :model="formDate">
          <el-form-item label="姓名" prop="customerName">
            <el-input v-model="formDate.customerName" disabled></el-input>
          </el-form-item>
          <el-form-item label="是否订餐" prop="orderId" >
            <!-- <el-input v-model="formDate.orderId" disabled></el-input> -->
            <el-input v-if="formDate.orderId" disabled placeholder="已订餐"></el-input>
            <el-input v-else disabled placeholder="未订餐"></el-input>
            <!-- <el-select
              v-model="formDate.orderId"
              disabled
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option label="已订餐" value=""></el-option>
              <el-option label="未订餐" value="1"></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="订餐方式" prop="orderWay">
            <!-- <el-input v-model="formDate.orderWay" disabled></el-input> -->
            <el-select
              v-model="formDate.orderWay"
              disabled
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option label="按月" value="0"></el-option>
              <el-option label="按次" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="就餐类型" prop="orderType">
            <el-select
              v-model="formDate.orderType"
              disabled
              placeholder="请选择"
              style="width: 100%"
            >
              <!-- <el-option label="未送餐" value="0"></el-option> -->
              <el-option label="早餐" value="1"></el-option>
              <el-option label="中餐" value="2"></el-option>
              <el-option label="晚餐" value="3"></el-option>
              <!-- <el-option label="已就餐" value="4"></el-option>
              <el-option label="未取餐" value="5"></el-option>
              <el-option label="已取餐" value="6"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="支付金额" prop="paymentAmount">
            <el-input v-model="formDate.paymentAmount" disabled></el-input>
          </el-form-item>
          <el-form-item label="支付方式" prop="payType">
            <el-select
              v-model="formDate.payType"
              disabled
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option label="人脸识别" value="1"></el-option>
              <el-option label="支付宝" value="2"></el-option>
              <el-option label="微信" value="3"></el-option>
              <el-option label="现金" value="4"></el-option>
            </el-select>
<!--            <el-input v-model="formDate.payType" disabled></el-input>-->
          </el-form-item>
          <el-form-item label="支付时间" prop="payTime">
            <el-input v-model="formDate.payTime" disabled></el-input>
          </el-form-item>
          <!-- <el-form-item label="附件">
            <el-upload
              action="#"
              list-type="picture-card"
              :auto-upload="false"
              :on-preview="handlePicturePreview"
              :on-change="handleAvatarSuccess"
              :on-success="
                (data, data1, data2) => imgSuccess('photo', data, data1, data2)
              "
              :file-list="photo"
              :on-remove="(file, fileList) => handleRemove2('photo', file, fileList)"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible1" append-to-body>
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </el-form-item> -->
        </el-form>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import { post } from "../../../api/requrestHttp";
export default {
  data() {
    return {
      list: {
        sum1: "",
        sum2: "",
        sum3: "",
        count1: "",
        count2: "",
        count3: "",
      },
      dialogVisible1: false,
      dialogImageUrl: "",
      pageNo: 1,
      pageSize: 10,
      tableDate: [],
      dialogVisible: false, //是否模态框
      formDate: {
        customerName: "",
        isOrder: "",
        orderMode: "",
        orderWay: "",
        paymentAmount: "",
        payType: "",
      },
      photo: [],
      total: 0,
    };
  },
  methods: {
    //每页请求数据
        handleSizeChange(val) {
            this.pageSize = val;
            this.showList();
            this.$message({
                message: `每页请求${val}条数据成功`,
                type: "success",
            });
        },
        //请求第几数据
        handleCurrentChange(val) {
            this.pageNo = val;
            this.showList();
            this.$message({
                message: `请求第${val}页数据成功`,
                type: "success",
            });
        },
    handleEdit(date) {
      console.log(date)
      this.dialogVisible = true;
      this.look(date);
    },
    // 表格数据
    showList() {
      post("/sqyl/admin/pay/index", {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        qujiId:JSON.parse(localStorage.getItem('czUserInfo')).qujiId,
		shengjiId:JSON.parse(localStorage.getItem('czUserInfo')).shengjiId,
		shijiId:JSON.parse(localStorage.getItem('czUserInfo')).shijiId,
		stationId:JSON.parse(localStorage.getItem('czUserInfo')).stationId,
		shequjiId:JSON.parse(localStorage.getItem('czUserInfo')).shequjiId
      }).then((res) => {
        // console.log(res);
        this.tableDate = res.content.list;
        this.total = res.content.count;
      });
    },

    look(date) {
      post("/sqyl/admin/pay/index", {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        id: date.id,
      }).then((res) => {
        this.formDate = res.content.list[0];
        // console.log(this.formDate);
      });
    },
    deleteId(date) {
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        post("/sqyl/admin/pay/indexDelete", {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          id: date.id,
        }).then((res) => {
          if (res.code == 200) {
            this.showList();
          }
        });
      });
    },
    handleAvatarSuccess(file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    handlePicturePreview(file) {
      this.dialogVisible1 = true;
      this.dialogImageUrl = file.url;
    },
    // 预览图片
    handlePicturePreview(file) {
      this.dialogVisible1 = true;
      this.dialogImageUrl = file.url;
    },

    // 统计
    sumNum() {
     
       post("/sqyl/admin/pay/payStatistics", {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        	qujiId:JSON.parse(localStorage.getItem('czUserInfo')).qujiId,
          shengjiId:JSON.parse(localStorage.getItem('czUserInfo')).shengjiId,
          shijiId:JSON.parse(localStorage.getItem('czUserInfo')).shijiId,
          stationId:JSON.parse(localStorage.getItem('czUserInfo')).stationId,
		  shequjiId:JSON.parse(localStorage.getItem('czUserInfo')).shequjiId
      }).then((res) => {
        // console.log(res);
        this.list = res.content;
      });
    },
  },
  created() {
    this.sumNum();
    this.showList();
  },
};
</script>

<style lang="less">
@font-face {
  font-family: "Unidtrsmled";
  src: url(../assets/font/UnidreamLED.ttf);
}
.payment_list_class {
  visibility: hidden;
}
.pay_manage_main {
  padding: 30px 42px;
  background: #ffffff;
  .pay_manage_title {
    position: relative;
    width: 100%;
    margin-bottom: 15px;
    &::after {
      position: absolute;
      left: 120px;
      right: 0;
      display: block;
      content: "";
      border-bottom: 1px solid #e4e7ed;
    }
    .title {
      box-sizing: border-box;
      display: inline-block;
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      color: #409eff;
      font-size: 14px;
      border: 1px solid #e4e7ed;
      border-bottom: none;
      border-radius: 4px 4px 0 0;
      box-sizing: border-box;
      background: #ffffff;
    }
  }
  .manage_header {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 36px;
    .header_item {
      flex: 0 0 22%;
      padding: 24px 20px;
      box-sizing: border-box;
      border-radius: 5px;
      &:not(:nth-child(4n + 1)) {
        margin-left: 4%;
      }
      &:nth-child(n + 5) {
        margin-top: 24px;
      }
      &:nth-child(1) {
        background: #eefefa url("../../../assets/paymentimg/c1.png") no-repeat right 15px
          bottom 15px;
        .price {
          font-size: 36px;
          font-family: Unidtrsmled;
          color: #4ef0c6;
        }
      }
      &:nth-child(2) {
        background: #ecf9fe url("../../../assets/paymentimg/c2.png") no-repeat right 15px
          bottom 15px;
        .price {
          font-size: 36px;
          font-family: Unidtrsmled;
          color: #38bcf4;
        }
      }
      &:nth-child(3) {
        background: #f1f2ff url("../../../assets/paymentimg/c3.png") no-repeat right 15px
          bottom 15px;
        .price {
          font-size: 36px;
          font-family: Unidtrsmled;
          color: #6d73ff;
        }
      }
      &:nth-child(4) {
        background: #edfaef url("../../../assets/paymentimg/c4.png") no-repeat right 15px
          bottom 15px;
        .price {
          font-size: 36px;
          font-family: Unidtrsmled;
          color: #0cbc29;
        }
      }
      &:nth-child(5) {
        background: #fefcef url("../../../assets/paymentimg/c5.png") no-repeat right 15px
          bottom 15px;
        .price {
          font-size: 36px;
          font-family: Unidtrsmled;
          color: #f0d330;
        }
      }
      &:nth-child(6) {
        background: #fff6f5 url("../../../assets/paymentimg/c6.png") no-repeat right 15px
          bottom 15px;
        .price {
          font-size: 36px;
          font-family: Unidtrsmled;
          color: #fca191;
        }
      }
      &:nth-child(7) {
        background: #fdf3fe url("../../../assets/paymentimg/c7.png") no-repeat right 15px
          bottom 15px;
        .price {
          font-size: 36px;
          font-family: Unidtrsmled;
          color: #ec7df5;
        }
      }
      &:nth-child(8) {
        background: #fde8f5 url("../../../assets/paymentimg/c8.png") no-repeat right 15px
          bottom 15px;
        .price {
          font-size: 36px;
          font-family: Unidtrsmled;
          color: #e91b9e;
        }
      }
      h5 {
        margin-bottom: 30px;
        color: #000000;
        font-size: 16px;
      }
      .price {
        padding-right: 40px;
        color: #41c0f5;
        font-size: 26px;
        font-weight: 400;
        text-align: center;
      }
    }
  }
  /deep/ .pagination_container {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      color: #606266;
      min-width: 30px;
      height: 36px;
      line-height: 36px;
      margin: 0;
      border-radius: 0;
      border: 1px solid #dddddd;
      border-radius: none;
      &.active {
        color: #ffffff;
        background: #337ab7;
      }
    }
    .el-pagination.is-background .btn-prev {
      border-top-left-radius: 2px;
      border-bottom-left-radius: 2px;
    }
    .el-pagination.is-background .btn-next {
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
    }

    .el-pagination.is-background .el-pager li {
      border-left: none;
      padding: 0px 16px;
      color: #337ab7;
    }
  }
  /deep/ .dialog_container {
    .el-dialog__header {
      border-bottom: 1px solid #e5e5e5;
    }
    .el-dialog__body {
      padding-left: 60px;
      padding-right: 60px;
    }
    .dialog_content {
      .el-col {
        text-align: center;
      }
      h3 {
        padding: 42px 0 24px 0;
        text-align: center;
      }
      .el-select {
        .el-input__inner {
          width: 100%;
        }
      }
      .payment_list_wrapper {
        display: flex;
        justify-content: flex-end;
        margin-top: 24px;
        .payment_list {
          display: flex;
          padding: 12px 42px;
          border-radius: 4px;
          border: 1px solid #dcdfe6;
          .payment_item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 0 24px;
            cursor: pointer;
            h6 {
              margin-top: 12px;
              font-size: 16px;
            }
          }
        }
      }

      .picture {
        width: 120px;
        height: 80px;
        background: red;
      }
    }
    .el-dialog__footer {
      background: #f5f5f5;
      padding: 8px 15px;
      border-top: 1px solid #e5e5e5;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }
}
</style>
